<template>
    <div>
        <v-toolbar color="lime darken-4" dark fixed flat dense app>
            <span class="hidden-md-and-up" v-on:click.stop="isSidenav = !isSidenav"> 
                <v-toolbar-side-icon>
                    
                </v-toolbar-side-icon> 
            </span>            
            <nav-title></nav-title>
            <v-spacer></v-spacer> 
            

            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn 
                    flat 
                    v-if="isAuth"
                    class="mb-0 pb-0 caption hidden-sm-and-down" 
                    v-on:click.stop="toggleExtension()"            
                    >
                    <v-icon left>search</v-icon>
                    {{searchtitle}}
                </v-btn> 
                
                <nav-menu-item 
                    v-for="(item, index) in menuItems"
                    :item="item"
                    :key="index">
                    
                </nav-menu-item>
                <v-spacer></v-spacer>                                               

                <v-btn 
                    flat  
                    class="mb-0 pb-0 hidden-sm-and-down" 
                    v-if="isAuth"
                    v-on:click="$emit('logout')">
                    <v-icon left>exit_to_app</v-icon>
                    Logout
                </v-btn>  

            </v-toolbar-items>            
        </v-toolbar>
        <v-expansion-panel v-if="searchshow==true" slot="extension" class="black--text grey">                           
            <nav-search-bar></nav-search-bar>
        </v-expansion-panel>
        <v-navigation-drawer
            temporary
            light    
            v-model="isSidenav"
            overflow
            absolute
            app
            >
            <v-list>
                <side-nav-menu-item 
                        v-for="(item, index) in menuItems"
                        :item="item"
                        :key="index"                        
                        >
                </side-nav-menu-item>
            </v-list> 
            <v-divider></v-divider>
            <v-list>
                <v-list-tile v-on:click.stop="toggleExtension()" >       
                    <v-list-tile-action>
                        <v-icon left>search</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>                            
                            {{searchtitle}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>        
            <v-divider></v-divider>
            <v-list v-if="isAuth">
                <v-list-tile v-on:click="$emit('logout')">       
                    <v-list-tile-action>
                            <v-icon left>exit_to_app</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>                            
                            Logout
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>


import MainNavMenuItem from './MainNavMenuItem.vue';
import MainNavSearchBar from './MainNavSearchBar.vue';
import MainNavTitle from './MainNavTitle.vue';
import SideNavMenuItem from './SideNavMenuItem.vue';
export default {   
    props: [
        'menuItems',
        'isAuth',
    ],
    components: {
        'nav-menu-item' : MainNavMenuItem,
        'nav-search-bar': MainNavSearchBar,
        'nav-title': MainNavTitle,
        'side-nav-menu-item' : SideNavMenuItem,
    },        
    data() {
        return {                                      
            
            isSidenav: false,            
            extensionContent:null,
            search:''
        }
    },
    computed: {                             
        searchtitle(){return this.searchshow?'Suche schließen':'Suche öffnen'},
        searchshow:{
            get(){return this.$store.getters['search/show']},
            set(value){this.$store.commit('search/SEARCH_SET_SHOW',value)}
        }
    },
    methods: {
                
        toggleExtension: function() {            
            this.searchshow=!this.searchshow            
        }
    }
    
}
</script>